import React from 'react';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import { TextField } from '@material-ui/core';
import MomentUtils from '@date-io/moment';

const DatePickerCustomTextField = ({...rest }) => {
	return <TextField margin="normal" variant="outlined" {...rest} />;
};

export const DataPicker = ({...rest}) => {
        return (
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<DatePicker TextFieldComponent={DatePickerCustomTextField}
							format="DD/MM/YYYY"
							cancelLabel="Cancelar"
							okLabel="Escolher"
							{...rest} />
			</MuiPickersUtilsProvider>);
};



// WEBPACK FOOTER //
// ./src/painel/components/DatePicker/index.js